import React, { useRef } from 'react';
import useServiceReveal from '../../hooks/useServiceReveal';
import { Link } from 'react-router-dom';
import Navbar from '../Navbar/MainNavbar/Navbar';
import Footer from '../Footer/Footer';
import './ServiceDetail.scss';
import ServiceProjects from './ServiceProjects';

export default function EditorialService({ page, heroImage, language }) {
  const isFa = language === 'fa';
  const root = useRef(null);
  useServiceReveal(root, `${page.title}-${language}`);
  return <div ref={root} className={`service-detail-page service-editorial ${isFa ? 'rtl-mode' : 'ltr-mode'}`}>
    <Navbar />
    <div className="service-detail-page__hero">
      <div className="service-detail-page__hero-image-wrapper">
        <img className="service-detail-page__hero-image" src={heroImage} alt="" />
        <div className="service-detail-page__hero-overlay" />
      </div>
      <div className="service-detail-page__hero-content"><h1 className="service-detail-page__hero-title">{page.title}</h1><div className="service-detail-page__hero-line" /></div>
    </div>
    <div className="service-detail-page__container">
      {page.intro && <div className="service-detail-page__intro"><p className="service-detail-page__intro-text" style={{whiteSpace:'pre-line'}}>{page.intro}</p></div>}
      <div className="service-detail-page__sections">
        {page.sections?.map((section,index) => <div className={`service-detail-page__section ${section.links ? "service-detail-page__section--catalog" : ""}`} key={section.title}>
          <div className="service-detail-page__section-number">{String(index+1).padStart(2,'0')}</div>
          <div className="service-detail-page__section-content">
            <h2 className="service-detail-page__section-title">{section.href ? <Link className="editorial-service-link" to={section.href}>{section.title}<span aria-hidden="true">{isFa ? '←' : '→'}</span></Link> : section.title}</h2>
            <div className="service-detail-page__section-divider" />
            {section.content && <p className="service-detail-page__section-text" style={{whiteSpace:'pre-line'}}>{section.content}</p>}
            {section.links && <ul className="service-project-links">{section.links.map(link => <li key={link.title}><Link to={link.href}>{link.title}<span aria-hidden="true">{isFa ? '←' : '→'}</span></Link></li>)}</ul>}
          </div>
        </div>)}
      </div>
      {page.projectIds && <ServiceProjects ids={page.projectIds} />}
      {page.parent && <Link className="custom__button" to={`/services/${page.parent}`}>{isFa ? 'بازگشت به خدمات' : 'Back to services'}</Link>}
    </div>
    <Footer />
  </div>;
}
